import { useMemo } from "react";

import { useFeatures } from "components/FeatureFlag";

import { useCommentFilterContext } from "../useCommentFilterContext";

export default function useCommentFilters() {
  const commentFilterFlag = useFeatures("comment-filters", undefined);
  const {
    taskUuid,
    clientWorkflowUuid,
    relatedEntityTitle,
    clearAllFilters,
    newStandaloneDraft,
  } = useCommentFilterContext();

  const activeFilters = useMemo(() => {
    if (taskUuid) {
      return [
        {
          type: "task",
          iconName: "check square",
          title: relatedEntityTitle,
          clear: clearAllFilters,
        },
      ];
    } else if (clientWorkflowUuid) {
      return [
        {
          type: "workflow",
          iconName: "list ul",
          title: relatedEntityTitle,
          clear: clearAllFilters,
        },
      ];
    }
    return [];
  }, [taskUuid, clientWorkflowUuid, relatedEntityTitle, clearAllFilters]);

  return {
    filterByTaskUuid: commentFilterFlag ? taskUuid : undefined,
    filterByClientWorkflowUuid: commentFilterFlag
      ? clientWorkflowUuid
      : undefined,
    activeFilters: commentFilterFlag ? activeFilters : [],
    ignoreCommentGid: newStandaloneDraft,
  };
}
